export const JOB_STATUS = {
  DRAFT: 'draft',
  IN_PROGRESS: 'in_progress',
  CLOSED: 'closed',
};

export const TEMPLATE_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
};

export const DEFAULT_STATUS_FILTERS = {
  publisher: [],
  inspector: [JOB_STATUS.IN_PROGRESS],
  report: [JOB_STATUS.IN_PROGRESS, JOB_STATUS.CLOSED],
  editor: [],
};

const STATUS_LABEL_KEYS = {
  [JOB_STATUS.DRAFT]: 'template_list.status_draft',
  [JOB_STATUS.IN_PROGRESS]: 'template_list.status_in_progress',
  [JOB_STATUS.CLOSED]: 'template_list.status_closed',
  [TEMPLATE_STATUS.ACTIVE]: 'template_list.status_active',
};

export const normalizeStatusValue = (status) => {
  const value = String(status || '').trim();
  if (!value) return undefined;

  const normalized = value.toLowerCase().replace(/[\s-]+/g, '_');
  const knownStatuses = [
    JOB_STATUS.DRAFT,
    JOB_STATUS.IN_PROGRESS,
    JOB_STATUS.CLOSED,
    TEMPLATE_STATUS.ACTIVE,
  ];

  if (knownStatuses.includes(normalized)) {
    return normalized;
  }

  if (normalized === 'inprogress') {
    return JOB_STATUS.IN_PROGRESS;
  }

  return undefined;
};

export const statusToCssClass = (status) =>
  (normalizeStatusValue(status) || JOB_STATUS.DRAFT).replace(/_/g, '-');

export const getStatusLabelKey = (status, tool) => {
  const normalized = normalizeStatusValue(status);
  if (normalized) {
    return STATUS_LABEL_KEYS[normalized] || STATUS_LABEL_KEYS[JOB_STATUS.DRAFT];
  }

  if (tool === 'editor') {
    return STATUS_LABEL_KEYS[TEMPLATE_STATUS.DRAFT];
  }

  return STATUS_LABEL_KEYS[JOB_STATUS.DRAFT];
};

export const getEffectiveJobStatus = (jobOrStatus, tool) => {
  if (!jobOrStatus) {
    return tool === 'editor' ? TEMPLATE_STATUS.DRAFT : JOB_STATUS.DRAFT;
  }

  if (typeof jobOrStatus === 'string') {
    return normalizeStatusValue(jobOrStatus) || JOB_STATUS.DRAFT;
  }

  if (jobOrStatus.status) {
    return normalizeStatusValue(jobOrStatus.status) || JOB_STATUS.DRAFT;
  }

  if (tool === 'editor') {
    return TEMPLATE_STATUS.DRAFT;
  }

  if (
    jobOrStatus.jobCompleted === true ||
    String(jobOrStatus.workStatusCode || '') === '2'
  ) {
    return JOB_STATUS.CLOSED;
  }

  return JOB_STATUS.DRAFT;
};
